module.exports = __webpack_public_path__ + "media/images/logo_one_line-3f702770.png";